const SideMiddle = () => {
  return (
    <div className="text-slate-200">
      <h2 className="text-slate-200 font-bold text-2xl mt-2 font-[Varela]">
        ADDRESS
      </h2>

      <div className="font-[Urbanist]">
        <p className="my-1">IIIT Ranchi</p>
        <p className="my-1">JUT, Ranchi </p>
        <p className="my-1">Jharkhand-834010</p>
      </div>
    </div>
  );
};
export default SideMiddle;
